export default __webpack_public_path__ + "static/brand-3-152f5e40d28d4faa7afc5ae12b166630.png";